import React from 'react'
import cx from 'classnames'

import { RadioGroup } from '../../../forms/RadioGroup/RadioGroup'
import { CardRadioGroupProps } from '../../interfaces'
import { CardRadioItem } from '../CardRadioItem'

import cm from './CardRadioGroup.module.css'

/**
 * CardRadioGroup component is a wrapper for CardRadio components which should be used to group them together.
 */
const CardRadioGroup = (props: CardRadioGroupProps) => {
  return <RadioGroup {...props} className={cx(cm.cardRadioGroup, props.className)} />
}

export default Object.assign(CardRadioGroup, {
  Item: CardRadioItem,
  Group: CardRadioGroup,
})
